import { LitElement, html, css } from 'https://cdn.jsdelivr.net/npm/lit@3/+esm';

class KlaviyoBlogFormCanada extends LitElement {
  createRenderRoot() {
    return this;
  }

  static styles = css`
    .klaviyo-blog-form-canada {
      margin: 40px 0;
    }
  `;

  render() {
    const country = window.Shopify?.country;

    if (country !== 'CA') {
      return html``;
    }

    return html`
      <div class="klaviyo-blog-form-canada">
        <div style="text-align: center; padding: 48px 0px 0px">
          <div class="klaviyo-form-RkCmYc"></div>
        </div>
      </div>
    `;
  }
}

customElements.define(
  'klaviyo-blog-form-canada',
  KlaviyoBlogFormCanada
);